"use client"
import { useRef } from "react"

// Menu mobile (design : <details> natif) — se referme quand on choisit un lien
export default function MobileMenu({ links, socials }) {
  const ref = useRef(null)
  const close = () => { if (ref.current) ref.current.open = false }
  return (
    <details ref={ref} className="nav-m" style={{ position: "relative" }}>
      <summary aria-label="Ouvrir le menu" style={{ width: 44, height: 44, borderRadius: 999, border: "1px solid #EFC3CF", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "#FFFFFF" }}>
        <svg width="18" height="12" viewBox="0 0 18 12" fill="none" aria-hidden="true"><path d="M1 1h16M1 6h16M1 11h10" stroke="#3D2A31" strokeWidth="1.5" strokeLinecap="round" /></svg>
      </summary>
      <nav aria-label="Menu mobile" style={{ position: "absolute", right: 0, top: 54, width: "min(300px, 86vw)", backgroundColor: "#FFFFFF", border: "1px solid #EFC3CF", borderRadius: 20, padding: 10, display: "flex", flexDirection: "column", boxShadow: "0 30px 60px -30px rgba(61, 42, 49, 0.35)" }}>
        {links.map(([href, label]) => (
          <a key={href} href={href} onClick={close} className="serif" style={{ color: "#3D2A31", textDecoration: "none", padding: "14px 16px", fontSize: 22 }}>{label}</a>
        ))}
        <div style={{ display: "flex", gap: 16, padding: "14px 16px 8px", borderTop: "1px solid #FBE9EE", marginTop: 6, fontSize: 13, fontWeight: 600 }}>
          {socials.map(([href, label]) => <a key={href} href={href} style={{ color: "#7A5D67" }}>{label}</a>)}
        </div>
      </nav>
    </details>
  )
}
